import React from 'react';

/**
 * Skeleton loader específico para las categorías del menú
 */
const CategorySkeletonLoader: React.FC = () => {
  return (
    <div className="bg-[#f8f9fa] border-b border-[#dee2e6] p-4">
      <div className="flex overflow-x-auto space-x-3 pb-2">
        {/* Skeleton para "Todos" */}
        <div className="flex-shrink-0 px-4 py-3 rounded-full text-center min-w-24 bg-[#f7ebd6] animate-pulse">
          <div className="w-6 h-6 bg-[#2C4358]/30 rounded mx-auto mb-1"></div>
          <div className="w-12 h-3 bg-[#2C4358]/30 rounded mx-auto"></div>
        </div>
        
        {/* Skeletons para categorías */}
        {[...Array(5)].map((_, index) => (
          <div key={index} className="flex-shrink-0 px-4 py-3 rounded-full text-center min-w-24 bg-white animate-pulse">
            <div className="w-6 h-6 bg-gray-200 rounded mx-auto mb-1"></div>
            <div className="w-16 h-3 bg-gray-200 rounded mx-auto"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySkeletonLoader; 